module.exports = __webpack_public_path__ + "img/slider-77.e522b0aa.jpg";